import script from "./wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./wrapper.vue?vue&type=script&setup=true&lang=js"

import "./wrapper.vue?vue&type=style&index=0&id=21457f78&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21457f78"]])

export default __exports__